import toJSON from './toJSON';
import toQuery from './toQuery';
import hasFile from './hasFile';

export default { toJSON, toQuery, hasFile };
